// extracted by mini-css-extract-plugin
export var button = "_bu-4";
export var hasDarkBackground = "_bu-7";
export var hasLightBackground = "_bu-6";
export var iconWrapper = "_bu-0";
export var large = "_bu-2";
export var medium = "_bu-1";
export var small = "_bu-5";
export var xsmall = "_bu-3";